var _a;
import { noteSchema } from './baseNoteSchema';
import { CNAppointmentNoteSchemaInstance } from './cnAppointmentNoteSchema';
import { careNavigatorUnscheduledNoteSchemaInstance, } from './careNavigatorUnscheduledNote';
import { couplesFamilyEhrNoteSchemaInstance, } from './couplesFamilyNoteSchema';
import { ehrNoteSchemaInstance } from './intakeFollowUpNoteSchema';
import { lateCancelNoteSchemaInstance } from './lateCancelNoteSchema';
import { minorEhrNoteSchemaInstance } from './minorNoteSchema';
import { notAttendedNoteSchemaInstance } from './notAttendedNoteSchema';
import { providerUnscheduledNoteSchemaInstance, } from './providerUnscheduledNoteSchema';
import { adultMedManagementNoteSchemaInstance } from './adultMedManagementNoteSchema';
import { minorMedManagementNoteSchemaInstance } from './minorMedManagementNoteSchema';
import { medManagerUnscheduledNoteSchemaInstance, } from './medManagerUnscheduledNoteSchema';
export var baseNoteSchemaInstance = {
    useDeprecatedFields: function () { return []; },
    useDeprecatedValues: function () { return ({}); },
};
export var noteSchemaInstanceMap = (_a = {},
    _a[noteSchema.followUp] = ehrNoteSchemaInstance,
    _a[noteSchema.intake] = ehrNoteSchemaInstance,
    _a[noteSchema.notAttended] = notAttendedNoteSchemaInstance,
    _a[noteSchema.lateCancel] = lateCancelNoteSchemaInstance,
    _a[noteSchema.couplesFamilyTherapyIntake] = couplesFamilyEhrNoteSchemaInstance,
    _a[noteSchema.couplesFamilyTherapyFollowUp] = couplesFamilyEhrNoteSchemaInstance,
    _a[noteSchema.minorTherapyIntake] = minorEhrNoteSchemaInstance,
    _a[noteSchema.minorTherapyFollowUp] = minorEhrNoteSchemaInstance,
    _a[noteSchema.providerUnscheduled] = providerUnscheduledNoteSchemaInstance,
    _a[noteSchema.careNavigatorUnscheduled] = careNavigatorUnscheduledNoteSchemaInstance,
    _a[noteSchema.careNavigatorInitial] = CNAppointmentNoteSchemaInstance,
    _a[noteSchema.careNavigatorFollowUp] = CNAppointmentNoteSchemaInstance,
    _a[noteSchema.adultMedManagementIntake] = adultMedManagementNoteSchemaInstance,
    _a[noteSchema.adultMedManagementFollowUp] = adultMedManagementNoteSchemaInstance,
    _a[noteSchema.minorMedManagementIntake] = minorMedManagementNoteSchemaInstance,
    _a[noteSchema.minorMedManagementFollowUp] = minorMedManagementNoteSchemaInstance,
    _a[noteSchema.medManagerUnscheduled] = medManagerUnscheduledNoteSchemaInstance,
    _a);
export var getSchemaDefaultValues = function (schemaInstance) {
    if (typeof schemaInstance.defaultValues === 'function') {
        return schemaInstance.defaultValues();
    }
    else {
        return schemaInstance.defaultValues;
    }
};
